import { render, staticRenderFns } from "./Keys.vue?vue&type=template&id=9bc6d258&"
import script from "./Keys.vue?vue&type=script&lang=ts&"
export * from "./Keys.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports